import { c as _c } from "react/compiler-runtime";
import { Server } from "lucide-react";
import { converterUrl } from "@/lib/converter";

/** Told on every server tool before anything is sent (CLAUDE.md: the only
 *  exception to hard rule 1; NFR-2). */
export const SERVER_PRIVACY_TEXT = "This tool sends your file to our server to convert it. It's deleted right after — we never keep or look at it.";
export function ServerNotice() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div role="note" className="flex items-start gap-3 rounded-xl border border-brand/25 bg-brand-tint px-4 py-3 text-[15px] text-ink"><Server className="mt-0.5 size-5 shrink-0 text-brand-strong" aria-hidden="true" /><p>{converterUrl ? <>{SERVER_PRIVACY_TEXT}{" "}<a href="/privacy/#server-tools" className="font-semibold underline underline-offset-4">How server tools handle files</a><span className="mt-1 block text-[13px] text-muted-foreground">Our converter is free software (AGPL-3.0):{" "}<a href={`${converterUrl}/source`} className="underline underline-offset-4">download its source code</a>.</span></> : "This tool needs our converter, which isn't available on this copy of the site. All the other tools work as usual."}</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}